// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/settingsPage/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/settingsPage/addProductOption */
export const useAddProductOption = makeBackendHook('settingsPage', 'addProductOption')

/** POST /api/rpc/settingsPage/deleteFixedCost */
export const useDeleteFixedCost = makeBackendHook('settingsPage', 'deleteFixedCost')

/** POST /api/rpc/settingsPage/deleteUnit */
export const useDeleteUnit = makeBackendHook('settingsPage', 'deleteUnit')

/** POST /api/rpc/settingsPage/describePhotoReference */
export const useDescribePhotoReference = makeBackendHook('settingsPage', 'describePhotoReference')

/** POST /api/rpc/settingsPage/fillDefaultPhoto */
export const useFillDefaultPhoto = makeBackendHook('settingsPage', 'fillDefaultPhoto')

/** POST /api/rpc/settingsPage/getDeletedItems */
export const useGetDeletedItems = makeBackendHook('settingsPage', 'getDeletedItems')

/** POST /api/rpc/settingsPage/getDescriptionAiSettings */
export const useGetDescriptionAiSettings = makeBackendHook('settingsPage', 'getDescriptionAiSettings')

/** POST /api/rpc/settingsPage/getFaireSettings */
export const useGetFaireSettings = makeBackendHook('settingsPage', 'getFaireSettings')

/** POST /api/rpc/settingsPage/getFixedCosts */
export const useGetFixedCosts = makeBackendHook('settingsPage', 'getFixedCosts')

/** POST /api/rpc/settingsPage/getPhotoCleanupSettings */
export const useGetPhotoCleanupSettings = makeBackendHook('settingsPage', 'getPhotoCleanupSettings')

/** POST /api/rpc/settingsPage/getProductDefaults */
export const useGetProductDefaults = makeBackendHook('settingsPage', 'getProductDefaults')

/** POST /api/rpc/settingsPage/getProductOptions */
export const useGetProductOptions = makeBackendHook('settingsPage', 'getProductOptions')

/** POST /api/rpc/settingsPage/getScheduledJobs */
export const useGetScheduledJobs = makeBackendHook('settingsPage', 'getScheduledJobs')

/** POST /api/rpc/settingsPage/getShippingFeeSettings */
export const useGetShippingFeeSettings = makeBackendHook('settingsPage', 'getShippingFeeSettings')

/** POST /api/rpc/settingsPage/getShippingSettings */
export const useGetShippingSettings = makeBackendHook('settingsPage', 'getShippingSettings')

/** POST /api/rpc/settingsPage/getTrackingEmailSettings */
export const useGetTrackingEmailSettings = makeBackendHook('settingsPage', 'getTrackingEmailSettings')

/** POST /api/rpc/settingsPage/getUnits */
export const useGetUnits = makeBackendHook('settingsPage', 'getUnits')

/** POST /api/rpc/settingsPage/getWholesaleTierMinimums */
export const useGetWholesaleTierMinimums = makeBackendHook('settingsPage', 'getWholesaleTierMinimums')

/** POST /api/rpc/settingsPage/removeProductOption */
export const useRemoveProductOption = makeBackendHook('settingsPage', 'removeProductOption')

/** POST /api/rpc/settingsPage/restoreDeletedItem */
export const useRestoreDeletedItem = makeBackendHook('settingsPage', 'restoreDeletedItem')

/** POST /api/rpc/settingsPage/runScheduledJob */
export const useRunScheduledJob = makeBackendHook('settingsPage', 'runScheduledJob')

/** POST /api/rpc/settingsPage/setFaireMinimum */
export const useSetFaireMinimum = makeBackendHook('settingsPage', 'setFaireMinimum')

/** POST /api/rpc/settingsPage/updateDescriptionAiSettings */
export const useUpdateDescriptionAiSettings = makeBackendHook('settingsPage', 'updateDescriptionAiSettings')

/** POST /api/rpc/settingsPage/updateFaireSettings */
export const useUpdateFaireSettings = makeBackendHook('settingsPage', 'updateFaireSettings')

/** POST /api/rpc/settingsPage/updatePhotoCleanupSettings */
export const useUpdatePhotoCleanupSettings = makeBackendHook('settingsPage', 'updatePhotoCleanupSettings')

/** POST /api/rpc/settingsPage/updateProductDefaults */
export const useUpdateProductDefaults = makeBackendHook('settingsPage', 'updateProductDefaults')

/** POST /api/rpc/settingsPage/updateShippingFeeSettings */
export const useUpdateShippingFeeSettings = makeBackendHook('settingsPage', 'updateShippingFeeSettings')

/** POST /api/rpc/settingsPage/updateShippingSettings */
export const useUpdateShippingSettings = makeBackendHook('settingsPage', 'updateShippingSettings')

/** POST /api/rpc/settingsPage/updateTrackingEmailSettings */
export const useUpdateTrackingEmailSettings = makeBackendHook('settingsPage', 'updateTrackingEmailSettings')

/** POST /api/rpc/settingsPage/updateWholesaleTierMinimum */
export const useUpdateWholesaleTierMinimum = makeBackendHook('settingsPage', 'updateWholesaleTierMinimum')

/** POST /api/rpc/settingsPage/upsertFixedCost */
export const useUpsertFixedCost = makeBackendHook('settingsPage', 'upsertFixedCost')

/** POST /api/rpc/settingsPage/upsertUnit */
export const useUpsertUnit = makeBackendHook('settingsPage', 'upsertUnit')
